export default (store) => {
  return {
    state: () => ({}),
    mutations: {},
    actions: {},
    getters: {},
  };
};
